require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2004-06-20-the-bandwidth-problem.json") })
        }
      }, "path---articles-2004-06-20-the-bandwidth-problem");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2004-06-20-the-bandwidth-problem!./.cache/json/articles-2004-06-20-the-bandwidth-problem.json
// module id = 351
// module chunks = 231608221292675